module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.confirmer.active) ? _c('v-layout', {
    attrs: {
      "row": "",
      "justify-center": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "value": _vm.confirmer.active,
      "persistent": "",
      "max-width": "600"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2"
  }, [_vm._v(_vm._s(_vm.confirmer.title))]), _vm._v(" "), (_vm.confirmer.body) ? _c('v-card-text', [_vm._v(_vm._s(_vm.confirmer.body))]) : _vm._e(), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _vm._l((_vm.confirmer.choices), function(choice, index) {
    return _c('v-btn', {
      key: index,
      attrs: {
        "color": "green darken-1",
        "flat": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.answer(choice.value)
        }
      }
    }, [_vm._v("\n            " + _vm._s(choice.text) + "\n         ")])
  })], 2)], 1)], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e21385c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialogs/ConfirmDialog.vue
// module id = 1179
// module chunks = 1